import { StyleSheet } from 'react-native';
import { ColorTypography } from 'src/theme-v2/color-typography';
import { textLatoStyleDS } from 'src/theme-v2/text';

export const styles = StyleSheet.create({
  inputCounter: {
    ...textLatoStyleDS.BodyRegularXs,
    color: ColorTypography.TextColorPlaceholder,
  },
  saveButton: {
    cursor: 'pointer',
  },
  saveButtonText: {
    ...textLatoStyleDS.BodyBoldSm,
    cursor: 'pointer',
    color: ColorTypography.TextColorInteractive,
    letterSpacing: 0,
  },
});
